import { mutationErrorCode } from '@src/lib/mutationErrors'

export const REQUEST_NOT_AUTHORIZED_MESSAGE = "You don't have access to this goal."

/** True when the API refused the caller, e.g. someone else's draft request. */
export const isRequestNotAuthorizedError = (error: unknown): boolean =>
  mutationErrorCode(error) === 'USER_NOT_AUTHORIZED'

/** Text for a failed request query: a plain sentence for "not yours", else the error itself. */
export const requestErrorMessage = (error: unknown): string =>
  isRequestNotAuthorizedError(error)
    ? REQUEST_NOT_AUTHORIZED_MESSAGE
    : (error as Error)?.message || String(error)
